export default function Bookcase(p: { higher?: boolean; children: any }) {
  return (
    <div className="Bookcase-back">
      <div className={`Bookcase${p.higher ? '_higher' : ''}`}> {p.children} </div>
    </div>
  );
}
